import { useCallback, useEffect } from 'react';
export const useClickHandler = ({ onPress, ref })=>{
    const handleClickOutside = useCallback((event)=>{
        if (ref.current && !ref.current.contains(event.target)) {
            onPress();
        }
    }, [
        ref,
        onPress
    ]);
    const handleEscapeKey = useCallback((event)=>{
        if (event.key === 'Escape') {
            onPress();
        }
    }, [
        onPress
    ]);
    useEffect(()=>{
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscapeKey);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [
        handleClickOutside,
        handleEscapeKey
    ]);
};

//# sourceMappingURL=use-click-handler.js.map